var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookmarkOutline = function SvgBookmarkOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.292 3H6.708c-1.054 0-1.907.9-1.907 2l-.01 16 6.709-3 6.708 3V5c0-1.1-.862-2-1.916-2m0 15L11.5 15.82 6.708 18V5h9.584z"
  })));
};
export default SvgBookmarkOutline;